import {
  FileTextIcon,
  ShieldAlertIcon,
  UsersIcon,
  UserIcon,
  CreditCardIcon,
  BarChart2Icon,
  SparklesIcon,
  ZapIcon,
  BriefcaseIcon,
  PackageIcon,
  ClipboardCheckIcon,
  RefreshCwIcon,
  Settings2Icon,
  ScanLineIcon,
  BookOpenIcon,
  LifeBuoyIcon,
  type LucideIcon,
} from 'lucide-react';
import { MODULES } from './modules';
import { ROUTES } from './routes';

export interface NavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  moduleId: string | null;
  /**
   * Backend permission key checked via can(). null = visible to all
   * authenticated staff regardless of role.
   */
  permission: string | null;
  /** Only visible when company.is_white_label is true */
  brandingOnly?: boolean;
}

export interface NavSection {
  section: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    section: 'OPERATIONS',
    items: [
      {
        label: 'Policies',
        href: ROUTES.POLICIES,
        icon: FileTextIcon,
        moduleId: MODULES.POLICY_ADMIN,
        permission: 'policy:read',
      },
      {
        label: 'UW Queue',
        href: '/dashboard/policies/queue',
        icon: ClipboardCheckIcon,
        moduleId: MODULES.POLICY_ADMIN,
        permission: 'policy:read',
      },
      {
        label: 'Renewals',
        href: ROUTES.POLICY_RENEWALS,
        icon: RefreshCwIcon,
        moduleId: MODULES.POLICY_ADMIN,
        permission: 'policy:renew',
      },
      {
        label: 'Claims',
        href: ROUTES.CLAIMS,
        icon: ShieldAlertIcon,
        moduleId: MODULES.CLAIMS,
        permission: 'claim:read',
      },
      {
        label: 'Clients',
        href: ROUTES.CLIENTS,
        icon: UsersIcon,
        moduleId: MODULES.CLIENT_AGENT,
        permission: 'client:read',
      },
      {
        label: 'Agents',
        href: ROUTES.AGENTS,
        icon: UserIcon,
        moduleId: MODULES.CLIENT_AGENT,
        permission: 'agent:read',
      },
      {
        label: 'Fast Inspections',
        href: ROUTES.INSPECTIONS,
        icon: ScanLineIcon,
        moduleId: MODULES.FAST_INSPECTIONS,
        permission: 'inspection:read',
      },
    ],
  },
  {
    section: 'FINANCE',
    items: [
      {
        label: 'Billing & Finance',
        href: ROUTES.BILLING,
        icon: CreditCardIcon,
        moduleId: MODULES.BILLING_FINANCE,
        permission: 'finance:read',
      },
    ],
  },
  {
    section: 'INTELLIGENCE',
    items: [
      {
        label: 'Analytics',
        href: ROUTES.ANALYTICS,
        icon: BarChart2Icon,
        moduleId: MODULES.ANALYTICS,
        permission: 'analytics:read',
      },
      {
        label: 'AI Intelligence',
        href: '/dashboard/copilot',
        icon: SparklesIcon,
        moduleId: MODULES.AI_COPILOT,
        permission: 'analytics:read',
      },
    ],
  },
  {
    section: 'AUTOMATION',
    items: [
      {
        label: 'STP Engine',
        href: ROUTES.STP_RULES,
        icon: ZapIcon,
        moduleId: MODULES.STP,
        permission: 'stp:read',
      },
    ],
  },
  {
    section: 'PEOPLE',
    items: [
      {
        label: 'HR & Staff',
        href: ROUTES.HR,
        icon: BriefcaseIcon,
        moduleId: MODULES.HR,
        permission: 'hr:read',
      },
    ],
  },
  {
    section: 'SETTINGS',
    items: [
      {
        label: 'Settings',
        href: ROUTES.SETTINGS_GENERAL,
        icon: Settings2Icon,
        moduleId: null,
        permission: 'settings:company',
      },
      {
        label: 'Products',
        href: ROUTES.PRODUCTS,
        icon: PackageIcon,
        moduleId: MODULES.POLICY_ADMIN,
        permission: 'product:read',
      },
      {
        label: 'User Guide',
        href: ROUTES.GUIDE,
        icon: BookOpenIcon,
        moduleId: null,
        permission: null,
      },
      {
        label: 'Help & Support',
        href: ROUTES.SUPPORT,
        icon: LifeBuoyIcon,
        moduleId: null,
        permission: null,
      },
    ],
  },
];
